import { ConsultaDisponibilidade } from "./ConsultaDisponibilidade";

export default ConsultaDisponibilidade;